module.exports = __webpack_public_path__ + "static/media/lease-rental-discounting.f24a03e3.jpg";